import { type ReactNode } from 'react'
import { getName } from '@terros/common'
import { createFileRoute } from '@tanstack/react-router'
import { useHomeScreenAnnouncement, useProfile } from '@front/model'
import { Page } from '@components'
import { HomeDashboardFeed } from './feed'
import { DisplayAnnouncement } from './Announcement'

export const HomePage = (): ReactNode => {
  const { user, hasPermission } = useProfile()
  const announcement = useHomeScreenAnnouncement()

  if (hasPermission('dashboard:list')) return <HomeDashboardFeed />

  return (
    <Page>
      <Page.Heading title={`Welcome, ${getName(user)}`} />
      <Page.Content>
        <DisplayAnnouncement announcement={announcement} />
      </Page.Content>
    </Page>
  )
}

export const Route = createFileRoute('/home/')({
  component: HomePage,
})
